import Vue from 'vue'
import { IonicVueRouter } from '@ionic/vue'
import AppLayout from '@/views/layout/App.vue'
import ExamVaultList from '@/views/ExamVault/ExamVaultList.vue'
import ExamVaultDetail from '@/views/ExamVault/ExamVaultDetail.vue'

Vue.use(IonicVueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    // New home lives in the v2 micro-app (modules/home).
    path: '/',
    name: 'Home',
    redirect: { name: 'V2' }
  },
  {
    // Old dashboards, kept during the transition.
    path: '/trang-chu-cu',
    name: 'LegacyHome',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/tin-tuc/:newsUrl',
    name: 'NewsDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/NewsDetail.vue')
  },
  {
    path: '/truong-hoc/:tab',
    name: 'School',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/School.vue')
  },
  {
    path: '/nha',
    name: 'MentorHouse',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/mentor-house/index.vue')
  },
  {
    path: '/microsoft-redirect',
    name: 'OneDriveRedirect',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/OneDriveRedirect.vue')
  },
  // Chuyên môn (Plan) served public schools, a segment no longer targeted.
  // {
  //   path: '/plan',
  //   name: 'Plan',
  //   meta: {
  //     layout: AppLayout
  //   },
  //   component: () => import('@/views/plan/Plan.vue')
  // },
  // {
  //   path: '/plan-leader',
  //   name: 'PlanLeader',
  //   meta: {
  //     layout: AppLayout
  //   },
  //   component: () => import('@/views/plan/PlanLeader.vue')
  // },
  // {
  //   path: '/plan-leader-detail/:planUid',
  //   name: 'PlanLeaderDetail',
  //   meta: {
  //     layout: AppLayout
  //   },
  //   component: () => import('@/views/plan/PlanLeaderDetail.vue')
  // },
  // {
  //   path: '/plan-teacher',
  //   name: 'PlanTeacher',
  //   meta: {
  //     layout: AppLayout
  //   },
  //   component: () => import('@/views/plan/PlanTeacher.vue')
  // },
  // {
  //   path: '/plan-teacher-detail/:planUid',
  //   name: 'PlanTeacherDetail',
  //   meta: {
  //     layout: AppLayout
  //   },
  //   component: () => import('@/views/plan/PlanTeacherDetail.vue')
  // },
  // {
  //   path: '/lesson-plan',
  //   name: 'PlanLesson',
  //   meta: {
  //     layout: AppLayout
  //   },
  //   component: () => import('@/views/plan/PlanLesson.vue')
  // },
  // {
  //   path: '/lesson-plan-detail/:planUid',
  //   name: 'PlanLessonDetail',
  //   meta: {
  //     layout: AppLayout
  //   },
  //   component: () => import('@/views/plan/PlanLessonDetail.vue')
  // },
  {
    path: '/lop-hoc',
    name: 'Class',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/Class.vue')
  },
  {
    path: '/trung-tam-khao-thi',
    name: 'RTContest',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/rtcontest/RTContest.vue')
  },
  {
    path: '/trung-tam-khao-thi/:contestId',
    name: 'RTContestDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/rtcontest/RTContestDetail.vue')
  },
  {
    path: '/bt-tuong-tac/:liveExamId',
    name: 'InteractiveHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/live-exam/LiveExam.vue')
  },
  {
    path: '/rung-chuong-vang',
    name: 'TRcvContest',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/t-rcv-contest/index.vue')
  },
  {
    path: '/rung-chuong-vang/:contestId',
    name: 'TRcvContestDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/t-rcv-contest/detail.vue')
  },
  {
    path: '/lop-hoc/:classUid/rcv/:contestId',
    name: 'RCVContestDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/rcv-contest/detail.vue')
  },
  {
    path: '/bao-cao',
    name: 'Reports',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/Reports.vue')
  },
  {
    path: '/bai-tap',
    name: 'ListClassHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ListClassHomeworks.vue')
  },
  {
    path: '/bai-hoc',
    name: 'ListClassStudy',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ListClassStudy.vue')
  },
  {
    path: '/giao-vien',
    name: 'ListTeacher',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ListTeacher.vue')
  },
  {
    path: '/lop-hoc/:classUid',
    name: 'ClassDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ClassDetail.vue')
  },
  {
    path: '/lop-hoc/:classUid/btvn-tai-len',
    name: 'ClassFileHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ClassFileHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/easy-class/',
    name: 'EasyClassHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/EasyClassHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/easy-ai/',
    name: 'EasyAIHomework',
    meta: {
      layout: AppLayout
    },
    component: () =>
      import('@/views/home-work/edit/EditPlatformHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/course-marketplace/',
    name: 'CourseMarketplaceHomework',
    meta: {
      layout: AppLayout
    },
    component: () =>
      import('@/views/home-work/edit/EditPlatformHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/unistart/',
    name: 'UnistartHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/UnistartHomework.vue')
  },
  {
    path: '/lop-hoc/mp/:classUid/:appId/',
    name: 'MpHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/MpHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/btvn-speaking',
    name: 'ClassAttachmentHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ClassAttachmentHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/create-mission/:missionTemplate',
    name: 'CreateMission',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/UpdateMission.vue')
  },
  {
    path: '/lop-hoc/:classUid/update-mission/:missionId',
    name: 'UpdateMission',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/UpdateMission.vue')
  },
  {
    path: '/lop-hoc/:classUid/create-mission-chain',
    name: 'CreateMissionChain',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/UpdateMissionChain.vue')
  },
  {
    path: '/lop-hoc/:classUid/update-mission-chain/:missionId',
    name: 'UpdateMissionChain',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/UpdateMissionChain.vue')
  },
  {
    path: '/lop-hoc/:classUid/mission/:missionId',
    name: 'MissionDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/MissionDetail.vue')
  },
  {
    path: '/lop-hoc/:classUid/mission-chain/:missionId',
    name: 'MissionChainDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/MissionChainDetail.vue')
  },
  {
    path: '/lop-hoc/:classUid/btvn-thu-vien',
    name: 'DocumentHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/DocumentHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/btvn-cau-hoi',
    name: 'ClassQuestionHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ClassQuestionHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/btvn-tu-vung',
    name: 'ClassVocabularyHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ClassVocabularyHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/btvn-hoi-thoai',
    name: 'ClassConversationHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ClassConversationHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/btvn-viet',
    name: 'ClassWritingHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ClassWritingHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/btvn-video',
    name: 'ClassVideoHomework',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ClassVideoHomework.vue')
  },
  {
    path: '/lop-hoc/:classUid/bttt-cau-hoi',
    name: 'ClassQuestionLiveExam',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/live-exam/ClassQuestionLiveExam.vue')
  },
  {
    path: '/lop-hoc/:classUid/:homeworkUid',
    name: 'ClassHomeWorkDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/home-work/result/index.vue')
  },
  {
    path: '/lop-hoc/:classUid/race-challenge/:raceChallengeId',
    name: 'RaceChallengeDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/race-challenge/Detail.vue')
  },
  {
    path: '/race-challenge/:raceChallengeId/missions/:missionId/questions',
    name: 'RaceChallengeMissionQuestions',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/race-challenge/questions/Question.vue')
  },
  {
    path: '/outing-game/:gameId',
    name: 'OutingGameDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/outing-game/Detail.vue')
  },
  {
    path: '/outing-game/:gameId/missions/:missionId/questions',
    name: 'OutingGameMissionQuestions',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/outing-game/questions/Question.vue')
  },
  {
    path: '/hoc-sinh',
    name: 'Students',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/Students.vue')
  },
  {
    // Replaced by the v2 student profile; StudentDetail.vue is kept but no longer routed.
    path: '/hoc-sinh/:studentId',
    name: 'StudentDetail',
    redirect: (to) => ({ path: `/v2/hoc-sinh/${to.params.studentId}`, query: to.query })
  },
  {
    path: '/tai-lieu',
    name: 'Document',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/Document.vue')
  },
  {
    path: '/tai-lieu/phan-quyen',
    name: 'Document-Permissions',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/DocumentPermission.vue')
  },
  {
    path: '/su-kien',
    name: 'Event',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/Event.vue')
  },
  {
    path: '/su-kien/:eventCode',
    name: 'EventContest',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/Contest.vue')
  },
  {
    path: '/su-kien/bxh/:eventCode',
    name: 'EventRanking',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/EventRanking.vue')
  },
  {
    path: '/su-kien/:eventCode/cuoc-thi/:contestCode',
    name: 'EventContestQuestion',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/ContestQuestion.vue')
  },
  {
    path: '/pricing',
    name: 'PricingPlan',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/PricingPlan.vue')
  },
  {
    path: '/huong-dan',
    name: 'Instruction',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/instruction/Instruction.vue')
  },
  {
    path: '/huong-dan/:id',
    name: 'InstructionDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/instruction/InstructionDetail.vue')
  },
  {
    path: '/lien-he',
    name: 'Contact',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/Contact.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/Profile.vue')
  },
  {
    path: '/kho-hoc-lieu',
    name: 'ExamVault',
    component: ExamVaultList,
    meta: {
      layout: AppLayout
    }
  },
  {
    path: '/kho-hoc-lieu/:examVaultId',
    name: 'ExamVaultDetail',
    component: ExamVaultDetail,
    meta: { layout: AppLayout }
  },
  // Bộ sách is dropped from the menu (PO, 2026-11).
  // {
  //   path: '/sgk',
  //   name: 'SchoolBookCategory',
  //   meta: {
  //     layout: AppLayout
  //   },
  //   component: () => import('@/views/book-categories/index.vue')
  // },
  {
    path: '/v2',
    name: 'V2',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/virtual-test-center',
    name: 'V2VirtualTestCenter',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/virtual-test-center/:roomId',
    name: 'V2TestRoomDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/virtual-test-center/:roomId/:testId',
    name: 'V2TestDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/virtual-test-center/:roomId/:testId/:sectionId',
    name: 'V2SectionDetail',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/resource-assignment',
    name: 'V2ResourceAssignment',
    meta: {
      layout: AppLayout
    },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/homework-leaderboard',
    name: 'V2HomeworkLeaderboard',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/hoc-sinh/:studentId',
    name: 'V2StudentProfile',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace',
    name: 'V2CourseMarketplace',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/settings',
    name: 'V2CmSettings',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/sales',
    name: 'V2CmSales',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/sales/overview',
    name: 'V2CmSalesOverview',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/sales/orders',
    name: 'V2CmSalesOrders',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/sales/enrollments',
    name: 'V2CmSalesEnrollments',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/b2b',
    name: 'V2CmB2b',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/b2b/browse',
    name: 'V2CmB2bBrowse',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/b2b/orders',
    name: 'V2CmB2bOrders',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/b2b/seller-orders',
    name: 'V2CmB2bSellerOrders',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/b2b/licenses',
    name: 'V2CmB2bLicenses',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/b2b/stats',
    name: 'V2CmB2bStats',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/:courseId',
    name: 'V2CmCourseDetail',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/:courseId/lessons/:lessonId',
    name: 'V2CmLessonDetail',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/:courseId/exercises/:exerciseId',
    name: 'V2CmExerciseDetail',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/:courseId/tests/:testId',
    name: 'V2CmTestDetail',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/course-marketplace/:courseId/lessons/:lessonId/conversations/:conversationId',
    name: 'V2CmConversationEditor',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  // Center / CRM module (v2)
  {
    path: '/v2/center/classes',
    name: 'V2CenterClasses',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/classes/:classId',
    name: 'V2CenterClassDetail',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/students',
    name: 'V2CenterStudents',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/students/:studentId',
    name: 'V2CenterStudentProfile',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/attendance',
    name: 'V2CenterAttendance',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/sessions/:sessionId',
    name: 'V2CenterSessionDetail',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/timetable',
    name: 'V2CenterTimetable',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/fees',
    name: 'V2CenterFees',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/timesheets',
    name: 'V2CenterTimesheets',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/payroll',
    name: 'V2CenterPayroll',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/center/settings',
    name: 'V2CenterSettings',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/crm',
    name: 'V2CrmOverview',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/crm/contacts',
    name: 'V2CrmContacts',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  },
  {
    path: '/v2/crm/opportunities',
    name: 'V2CrmOpportunities',
    meta: { layout: AppLayout },
    component: () => import('@/views/v2/V2Container.vue')
  }
]

const router = new IonicVueRouter({
  mode: Vue.prototype.$myDevice === 'isMobileApp' ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes: routes
})

// IonicVueRouter's async confirmTransition leaves NavigationDuplicated
// rejections uncaught when a tab re-navigates to the current route.
// Swallow only that failure type; rethrow everything else.
const silenceDuplicate = fn => function(location, onResolve, onReject) {
  if (onResolve || onReject) return fn.call(this, location, onResolve, onReject)
  return fn.call(this, location).catch(err => {
    if (err?.name === 'NavigationDuplicated') return
    return Promise.reject(err)
  })
}
router.push = silenceDuplicate(router.push)
router.replace = silenceDuplicate(router.replace)

export default router
